// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_math from "../../../../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as CookieHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as CookieConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";

function clampPercent(p) {
  if (p < 0) {
    return 0;
  } else if (p > 100) {
    return 100;
  } else {
    return p;
  }
}

function hexDigitToInt(c) {
  var match = c.toLowerCase();
  switch (match) {
    case "0" :
        return 0;
    case "1" :
        return 1;
    case "2" :
        return 2;
    case "3" :
        return 3;
    case "4" :
        return 4;
    case "5" :
        return 5;
    case "6" :
        return 6;
    case "7" :
        return 7;
    case "8" :
        return 8;
    case "9" :
        return 9;
    case "a" :
        return 10;
    case "b" :
        return 11;
    case "c" :
        return 12;
    case "d" :
        return 13;
    case "e" :
        return 14;
    case "f" :
        return 15;
    default:
      return -1;
  }
}

function getRolloutedValues(visitorId, percentOpt) {
  var percent = percentOpt !== undefined ? percentOpt : 10;
  var len = visitorId.length;
  if (len === 0) {
    return false;
  }
  var lastChar = Js_string.charAt(len - 1 | 0, visitorId);
  var hexVal = hexDigitToInt(lastChar);
  if (hexVal < 0) {
    return false;
  }
  var p = clampPercent(percent);
  var bucket = Js_math.floor_int(p * 16.0 / 100.0);
  return hexVal < bucket;
}

function getIsContainsVisitorId(percentOpt) {
  var percent = percentOpt !== undefined ? percentOpt : 10;
  var id = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.visitorId);
  return getRolloutedValues(id, percent);
}

export {
  clampPercent ,
  hexDigitToInt ,
  getRolloutedValues ,
  getIsContainsVisitorId ,
}
/* CookieHelpers-PorterinUtils Not a pure module */
